export default {"src":"/_next/static/media/cz.c4ee1308.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};